export enum LayoutType  {
    Dashboard,
    Report,
    All
}
